import { Component, OnInit, Input } from "@angular/core";
import { SectorsAndIndustriesPageDataService } from "../sectors-and-industries-page-data-service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-sector-details",
  templateUrl: "./sector-details.component.html",
  styleUrls: ["./sector-details.component.scss"],
})
export class SectorDetailsComponent implements OnInit {
  @Input() sectorId: number;
  @Input() sectorName: string;
  @Input() imageName: string;
  @Input() hasCompsAccess: boolean;
  loading = true;
  industryData = [];
  imageSrc: string;
  sectorLink: string;
  companiesCount: number;
  legacyUrl = `${window.caUrl}/app`;
  constructor(private dataService: SectorsAndIndustriesPageDataService) {}

  ngOnInit() {
    this.imageSrc = `${environment.assetUrl}/${this.imageName}.png`;
    this.sectorLink = `/reporting/sector/${this.sectorName}`;
    this.dataService
      .getIndustryDetailsBySector(this.sectorId)
      .subscribe((data) => {
        this.companiesCount = data.count;
        this.industryData = data.industry_list;
        this.loading = false;
      });
  }
}
